<mat-card class="content-card">
  <mat-card-header fxLayoutAlign="space-between center">
    <mat-card-title>
      <h5>Other templates</h5>
    </mat-card-title>
    <div fxFlex></div>
    <a mat-raised-button color="primary" routerLink="others/add">Add</a>
  </mat-card-header>

  <mat-card-content>
    <mat-nav-list role="list">

      <div fxLayout="row" *ngFor="let template of templates">
        <a mat-list-item fxFlex [routerLink]="'others/' + template.name"><span style="width:100%">{{template.documentName || template.name}}</span>
          <mat-icon >edit</mat-icon>
        </a>
      </div>

    </mat-nav-list>
  </mat-card-content>
</mat-card>
